The input parameter for the `updateUploadedCandidateProfileDates` mutation.
